<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import CategoryCard from "@/components/cards/CategoryCard";
import appConfig from "@/app.config";


export default {
  page: {
    title: "Support",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout, Heading, CategoryCard
  },
  data() {
    return {
      page: {
        title: "Support",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      },
      categories: [
        {
          name: "Laptop",
          additionalProp1: {
            icon: "laptop-icon.svg",
            link: "/support"
          }
        },
        {
          name: "Troubleshooting",
          additionalProp1: {
            icon: "troubleshooting-icon.svg",
            link: "/support"
          }
        }
      ]
    };
  },
  mounted() {
    // this.$forceUpdate();
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="pl-page-container">
      <div class="pl-categories">
        <router-link class="text-dark" v-for="(category, index) in categories" :to="category.additionalProp1.link" :key="index">
          <CategoryCard :icon="category.additionalProp1.icon" :name="category.name" />
        </router-link>
      </div>
    </div>
  </Layout>
</template>